export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_17.12691110.jpg";